/**
 * Janoshik Analytical lab reports for products that have one.
 *
 * Keyed by product slug. Future products opt in by adding an entry.
 * The homepage feature block uses `getFeaturedJanoshikReport()` which
 * returns the most recently analyzed report (or null if the map is empty).
 *
 * All visible copy lives in src/messages/*.json under the `janoshik`
 * namespace. Dates are ISO strings here and formatted per-locale at
 * render time with next-intl's formatter (no hardcoded "11. Mai 2026").
 */

export interface JanoshikReport {
	productSlug: string;
	productLabel: string;
	taskNumber: string;
	purityPercent: number;
	activeSubstanceMg: number;
	declaredMg: number;
	orderedAt: string;
	receivedAt: string;
	analyzedAt: string;
	verifyKey: string;
	verifyUrl: string;
	thumbnailImageSrc: string;
	reportImageSrc: string;
	testDescription: string;
}

export const JANOSHIK_REPORTS: Record<string, JanoshikReport> = {
	retatrutide: {
		productSlug: "retatrutide",
		productLabel: "Retatrutide 10 mg",
		taskNumber: "147356",
		purityPercent: 99.588,
		activeSubstanceMg: 10.92,
		declaredMg: 10,
		orderedAt: "2026-04-13",
		receivedAt: "2026-05-07",
		analyzedAt: "2026-05-11",
		verifyKey: "S15GPICWV71H",
		verifyUrl: "https://verify.janoshik.com/tests/147356_S15GPICWV71H",
		thumbnailImageSrc: "/lab-reports/retatrutide-10mg-147356-thumb-440w.webp",
		reportImageSrc: "/lab-reports/retatrutide-10mg-147356.png",
		testDescription: "Common GLP-1 peptide blind test (Semaglutide, Tirzepatide and Retatrutide)",
	},
};

export const JANOSHIK_LOGO_SRC = "/lab-reports/janoshik-logo-92x56.webp";

export function getJanoshikReportForSlug(slug: string): JanoshikReport | null {
	return JANOSHIK_REPORTS[slug] ?? null;
}

export function getFeaturedJanoshikReport(): JanoshikReport | null {
	const reports = Object.values(JANOSHIK_REPORTS);
	if (reports.length === 0) return null;
	return reports.reduce((latest, current) =>
		Date.parse(current.analyzedAt) > Date.parse(latest.analyzedAt) ? current : latest,
	);
}
